import { globalConstants } from "../constants";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";

async function getBoatTypes() {
  return getRequest(`/${globalConstants.VERSION}/BoatType/all`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getClasses() {
  return getRequest(`/${globalConstants.VERSION}/Class/all`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getAllBoatClass(gridData) {
  return postRequest(
    `/${globalConstants.VERSION}/BoatClass/all`,
    gridData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getBoatClassById(id) {
  return getRequest(`/${globalConstants.VERSION}/BoatClass/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function addBoatClass(BoatClassData) {
  return postRequest(
    `/${globalConstants.VERSION}/BoatClass`,
    BoatClassData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function updateBoatClass(BoatClassData) {
  return putRequest(
    `/${globalConstants.VERSION}/BoatClass`,
    BoatClassData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function deleteBoatClassById(id) {
  return deleteRequest(`/${globalConstants.VERSION}/BoatClass/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getAllGenderBoatClass() {
  return getRequest(
    `/${globalConstants.VERSION}/BoatClass/genderBoatClass`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

export const boatTypeService = {
  getBoatTypes,
  getClasses,
  getAllBoatClass,
  getBoatClassById,
  addBoatClass,
  updateBoatClass,
  deleteBoatClassById,
  getAllGenderBoatClass,
};
